/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$('.custom__item--16342196125a239904-0 a, .card__read-more').addClass('btn btn--secondary feature-row__btn');